import { render, staticRenderFns } from "./SizeVariantsMapping.vue?vue&type=template&id=71221197&scoped=true"
import script from "./SizeVariantsMapping.vue?vue&type=script&lang=js"
export * from "./SizeVariantsMapping.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SizeVariantsMapping.vue?vue&type=style&index=0&id=71221197&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "71221197",
  null
  ,true
)

export default component.exports